export enum HostSlideoutTab {
  Account = 'account',
  SystemHealth = 'system-health',
  FeatureUsage = 'feature-usage',
  EventLog = 'event-log',
  Notes = 'notes',
}
